import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './TournamentsList.module.scss';
import { TournamentsTable } from './components/TournamentsTable/TournamentsTable';
import { Loader } from '../Shared/Loader/Loader';
import { useGetTournamentsList } from '../../hooks/useGetTournamentsList';
import { GreenButton } from '../Shared/GreenButton/GreenButton';

export const TournamentsList = () => {
    const navigate = useNavigate();
    const { data, isLoading } = useGetTournamentsList({});

    return (
        <div className={styles.container}>
            <div className={styles.titleRow}>
                <div className={styles.title}>Tournaments</div>
                <GreenButton onClick={() => navigate('/tournaments/create')} noMargin>
                    + Create Tournament
                </GreenButton>
            </div>
            <div className={styles.row}></div>

            {isLoading ? (
                <Loader />
            ) : (
                <TournamentsTable data={data?.entities} />
            )}
        </div>
    );
};
